import { render, staticRenderFns } from "./communityApplicationMessageDetail.vue?vue&type=template&id=ed744fa6&"
import script from "./communityApplicationMessageDetail.vue?vue&type=script&lang=js&"
export * from "./communityApplicationMessageDetail.vue?vue&type=script&lang=js&"
import style0 from "./communityApplicationMessageDetail.vue?vue&type=style&index=0&id=ed744fa6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports